<div class="conteudo" >
  <div class="container p-0 p-3">
    <div class="subtitulo">
      <span class="text" >Confirmação de entrega</span>
      <div *ngIf="formularioConfigApp.get('config').value != 0" class="container-tooltip custom-control-inline" > 
        <img src="assets/img/icons/icon-info-circle.svg"
         style="font-size:15px; padding: 5px; " 
          placement="right" 
          tooltipClass="custom-tooltip" 
          ngbTooltip="Os comprovantes são disponibilizados pela Target por até 1 ano, é de responsabilidade da distribuidora o armazenamento (download) do comprovante para obrigações fiscais por até 5 anos." 
          class="fa fa-warning"
          tooltipClass="classTooltip">
      </div>
    </div>
    
    <form [formGroup]="formularioConfigApp" (change)="atualizaConfigApp()">
      <div class="input-radios">
        <div class="radio-wrapper">
          <input type="radio" id="customRadio1" value="0" name="customRadio" formControlName="config">
          <label for="customRadio1">Nenhum</label>
        </div>

        <div class="radio-wrapper">
          <input type="radio" id="customRadio2" value="1" name="customRadio" formControlName="config">
          <label for="customRadio2">Assinatura</label>
        </div>

        <div class="radio-wrapper">
          <input type="radio" id="customRadio3" value="2" name="customRadio" formControlName="config"> 
          <label for="customRadio3">Foto</label>
        </div>

         <div class="radio-wrapper">
          <input type="radio" id="customRadio4" value="3" name="customRadio" formControlName="config"> 
          <label for="customRadio4">Assinatura ou Foto</label>
        </div>
      </div>
    </form>   
       
    <div class="check-container">
      <div *ngIf="contemManterSequenciaEntrega !== null" class="d-flex">
        <form [formGroup]="formularioManterSequencia" (change)="atualizaManterSequencia()">
          <div class="custom-checkbox">
            <input type="checkbox" id="manterSequencia" class="custom-input" formControlName="manterSequenciaEntrega">
            <label class="custom-control-label text" for="manterSequencia">Obrigar motorista manter sequência de entrega</label>
          </div>
        </form>   
      </div>
    
      <div class="">
        <form [formGroup]="formularioPermitirIniciar" (change)="atualizaPermiInicRotAntesPrevisao()">
          <div class="custom-checkbox">
            <input type="checkbox" id="permitirIniciarRoteiroAntesPrevisao" class="custom-input" formControlName="permitirIniciarRoteiroAntesPrevisao">
            <label class="custom-control-label text" for="permitirIniciarRoteiroAntesPrevisao">Permitir iniciar o roteiro antes da Previsão de Saída</label>
          </div>
        </form>    
      </div>  
    </div>

      <div class="d-flex justify-content-center mt-2">
        <app-texto-link
        [disabled]="controlaJornadaMotorista || loading || chaveDispositivoAcesso == null || dados.roteiroLimpo"
        titulo="Desconectar veículo "
        icone='icon-truck-block'
        (click)="desconectarVeiculo()"
        > 
        </app-texto-link>
      </div>

      <box-acoes [roteiro]="dados" ></box-acoes> 
    </div> 

    <div class="d-flex justify-content-end mt-2">
      <app-texto-link titulo="Fechar" (click)="fecharModalConfig()"></app-texto-link>
    </div>

</div>
